import { createReducer, isAnyOf } from '@reduxjs/toolkit';
import type { IAuthUser, IError, StatusLoading } from 'types/Common';
import { currentUser, login, logout, setLoginError, updateLoginForm } from 'store/actions/authActions';

export interface AuthState {
  isAuthenticated: boolean;
  authenticatedStatus: null | StatusLoading;
  user: IAuthUser | null;
  error: null | IError;
  loginFormValues: { username: string; password: string };
}

const initialState: AuthState = {
  isAuthenticated: false,
  authenticatedStatus: 'pending',
  user: null,
  error: null,
  loginFormValues: { username: '', password: '' },
};

const authReducer = createReducer<AuthState>(initialState, (builder) => {
  builder
    .addCase(currentUser.fulfilled, (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.authenticatedStatus = 'succeeded';
    })
    .addCase(currentUser.pending, (state) => {
      state.authenticatedStatus = 'pending';
    })
    .addCase(currentUser.rejected, (state) => {
      state.isAuthenticated = false;
      state.authenticatedStatus = 'failed';
    })
    .addCase(login.fulfilled, (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.loginFormValues = { username: '', password: '' };
      state.error = null;
    })
    .addCase(login.rejected, (state, action) => {
      state.isAuthenticated = false;
      state.user = null;
      state.error = action.payload
        ? { error: action.payload.message || 'Login fehlgeschlagen', status: action.payload.status || 401 }
        : { error: 'Login fehlgeschlagen', status: 401 };
    })
    .addCase(setLoginError, (state, action) => {
      state.error = action.payload;
    })
    .addCase(updateLoginForm, (state, action) => {
      state.loginFormValues = action.payload;
    })
    .addMatcher(isAnyOf(logout.fulfilled, logout.rejected), (state) => {
      state.isAuthenticated = false;
      state.user = null;
    });
});

export default authReducer;
